import { Box } from "@remo-co/ui-core/src/components/Box";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Trans } from "react-i18next";
import { useStyles } from "./styles";

const termsAndConditionsLink = "https://remo.co/terms-of-service/";
const privacyAndPolicyLink = "https://remo.co/privacy-policy/";

export const TCAndPrivacyPolicyDisclaimer = () => {
  const classes = useStyles();

  return (
    <Box className={classes.tcPrivacyPolicyCheckboxContainer}>
      <Box>
        <Typography>
          <Trans i18nKey="auth:terms.condition">
            By signing up for an account, you agree to the
            <a
              href={termsAndConditionsLink}
              rel="noopener noreferrer"
              target="_blank"
            >
              Terms & Conditions
            </a>
            and
            <a
              href={privacyAndPolicyLink}
              rel="noopener noreferrer"
              target="_blank"
            >
              Privacy policy
            </a>
          </Trans>
        </Typography>
      </Box>
    </Box>
  );
};
